import { render, staticRenderFns } from "./ManageZIPCodes.vue?vue&type=template&id=114bcffc&scoped=true&"
import script from "./ManageZIPCodes.vue?vue&type=script&lang=js&"
export * from "./ManageZIPCodes.vue?vue&type=script&lang=js&"
import style0 from "./ManageZIPCodes.vue?vue&type=style&index=0&id=114bcffc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "114bcffc",
  null
  
)

export default component.exports